import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
// Page Components
import Greetings from './components/Greetings/Greetings';
import CurrentBalance from 'components/CurrentBalance/CurrentBalance';
import OptionsCards from './components/OptionsCards/OptionsCards';
import AccountDetails from 'components/AccountDetails/AccountDetails';
import PlanDetails from 'components/PlanDetails/PlanDetails';
import Detail from 'components/PlanDetails/Detail';
import EditPaymentMethod from 'components/PlanDetails/EditPaymentMethod';
import CompleteAndUpdate from './components/CompleteAndUpdate/CompleteAndUpdate';

// Const and utils
import { CustomerStatus } from 'common/consts/customerStatus';

// Page styles
import styles from './DebtOverviewPageData.module.scss';
import ManualPaymentBanner from './components/ManualPaymentBanner/ManualPaymentBanner';
import { ManualPaymentBannerType } from 'common/consts/manualPaymentBanner';
import SecuredPerformCard from './components/SecuredPerformcard/SecuredPerformCard';
import SecuredAlert from './components/SecuredAlert/SecuredAlert';
import SecuredRepaymentList from './components/SecuredRepaymentList/SecuredRepaymentList';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const DebtOverviewPageDataSecured = (props: Props) => {
  const history = useHistory();
  const { Model, PageData, LayoutModel } = props;

  const hasMultipleProfiles = (LayoutModel?.Profiles || []).length > 1;

  return (
    <div className={styles.wrapper} id={styles.test}>
      <div className={styles.section}>
        <Greetings
          greeting={PageData?.Greeting}
          username={Model?.UserFullName}
          hasMultipleAccounts={hasMultipleProfiles}
          multipleAccountLabel={PageData?.MyaccountsLabel}
        />
      </div>

      {Model?.CustomerStatus != CustomerStatus.AccountClosed &&
        Model.DisplayManualPaymentBanner != null &&
        Model.DisplayManualPaymentBanner != ManualPaymentBannerType.None &&
        (Model?.Profile?.Segment == "5" || Model?.Profile?.Segment == "1")&& (
          <div className={styles.section}>
            <ManualPaymentBanner {...props} />
          </div>
        )}
      {Model?.DisplayAttentionUrgentSection && (
        <div className={styles.section}>
          <SecuredAlert {...props} />
        </div>
      )}
      <div className={styles.section}>
        <SecuredPerformCard {...props} />
      </div>

      {(Model.IsCurrentBalanceVisible ||
        Model.IsCmsEditMode ||
        (Model.PaymentPlan !== null 
          && Model.CustomerStatus !== CustomerStatus.ClosingInProgress)) 
           && (
        <div className={styles.section}>
          <CurrentBalance
            heading={PageData?.MyCurrrentBalanceHeading}
            currency={Model?.Balance?.Currency}
            balance={(Model?.showPlanCurrentBalance) ? Model?.PaymentPlan?.CurrentBalanceAmountText : Model?.FormattedCurrencyDebtBalance}
            balanceTooltip={PageData?.MyCurrentBalanceTooltip}
            noPaymentPlan={
              Model?.PaymentPlan?.NoPaymentPlan || Model?.IsCmsEditMode
            }
            noPaymentPlanHeading={PageData?.NoPaymentplanHeading}
            noPaymentPlanTooltip={PageData?.NoPaymentplanTooltip}
            CurrentBalanceSecuredParaText={
              PageData?.CurrentBalanceSecuredParaText
            }  
            ShowCurrentBalanceEmpty = {Model?.showPlanCurrentBalance && Model?.IsNewPayment}                 
          ></CurrentBalance>
        </div>
      )}

      {Model.CustomerStatus !== CustomerStatus.AccountClosed && (
        <>
          {Model.PaymentPlan !== null && !Model.PaymentPlan.NoPaymentPlan 
           && (
            <div className={styles.section}>
              <SecuredRepaymentList {...props} />
            </div>
          )}
          {!Model.HideBalanceCtaPaymentPlan && (
          <div className={styles.section}>
            <OptionsCards {...props} />
          </div>
          )}
          {((Model?.ContactDetails?.HasDataCompletenessPercentValue &&
            Model?.ContactDetails?.DataCompletenessPercent < 100) ||
            Model?.IsCmsEditMode) && (
            <div className={styles.section}>
              <CompleteAndUpdate
                mainText={PageData?.DataCompletenessBeginningLabel}
                percents={Model?.ContactDetails.DataCompletenessPercent}
                highlightedText={PageData?.DataCompletenessEndingLabel}
                buttonText={PageData?.DataCompletenessButtonLabel}
                buttonUrl={Model?.CustomerProfilePageUrl}
              />
            </div>
          )}
          <div className={styles.section}>
            <AccountDetails {...props} />
          </div>
        </>
      )}
    </div>
  );
};

export default DebtOverviewPageDataSecured;
